import { DeliveryTimeUnits, DeliveryTypes } from "@utils/enums";

import { DeliveryOption } from "@components/Product/ECommerce/eCommerce.types";

import { FullProductApiModel } from "lib/@types/service/product/api/product.api.model";

const deliveryItemMapper = (
    type: string,
    product: FullProductApiModel,
): DeliveryOption => {
    const deliveryOption: Partial<DeliveryOption> = {
        deliveryType: type as DeliveryTypes,
    };
    if (DeliveryTypes.HomeDelivery === type) {
        deliveryOption.deliveryTime = product.homeDeliveryTime;
        deliveryOption.deliveryTimeInHours = product.homeDeliveryTimeInHours;
        deliveryOption.deliveryTimeUnit =
            product.homeDeliveryTimeUnit as DeliveryTimeUnits;
        deliveryOption.deliveryCost = product.price?.deliveryCost || 0;
    } else if (DeliveryTypes.ClickAndCollect === type) {
        deliveryOption.deliveryTime =
            product.clickAndCollectDeliveryTimeInHours;
        deliveryOption.deliveryTimeInHours =
            product.clickAndCollectDeliveryTimeInHours;
        deliveryOption.deliveryTimeUnit = DeliveryTimeUnits.Hours;
        deliveryOption.deliveryCost = 0;
    }
    return deliveryOption as DeliveryOption;
};

export { deliveryItemMapper };
